<script setup>
import { ref } from 'vue';

const props = defineProps({
  blur: {
    type: Boolean,
  },
});
const emit = defineEmits(['changeBlur']);
import Eye from '@/components/ui/icons/EyeBlur.vue';
import EyeClose from '@/components/ui/icons/EyeCloseBlur.vue';

const isBlur = ref(props.blur);

const changeBlur = () => {
  isBlur.value = isBlur.value === true ? false : true;
  emit('changeBlur');
};

watch(blur, (val) => {
  isBlur.value = val;
});
</script>

<template>
  <div class="toggle-switch">
    <label>
      <input
        type="checkbox"
        :checked="isBlur"
        @change="changeBlur"
      >
      <span class="slider">
        <span class="toggle">
          <Transition name="icon">
            <Eye
              v-if="!isBlur"
              class="toggle__icon toggle__icon--sun"
            />
            <EyeClose
              v-else
              class="toggle__icon toggle__icon--moon"
            />
          </Transition>
        </span>
      </span>
    </label>
  </div>
</template>

<style lang="scss" scoped>
.toggle-switch {
  position: relative;
  min-width: 64px;
  width: 64px;
  max-width: 64px;
  height: 40px;
  @media (max-width: 768px) {
    min-width: 46px;
    width: 46px;
    max-width: 46px;
    height: 26px;
  }
}

input {
  display: none;
}

.slider {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: var(--transition-fast);
  border-radius: 50px;
  background-color: var(--sub-bg);
  cursor: pointer;
}

.slider .toggle {
  content: '';
  display: flex;
  position: absolute;
  top: 50%;
  left: 4px;
  justify-content: center;
  align-items: center;
  transform: translate(0, -50%);
  transition: all var(--transition-fast);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  background-color: var(--wp-surface-default);

  svg {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
    left: 3px;

    svg {
      width: 14px;
      height: 14px;
    }
  }
}

input:checked ~ .slider .toggle {
  left: 28px;
  box-shadow: none;

  @media (max-width: 768px) {
    left: 23px;
  }
}

.icon-enter-active,
.icon-leave-active {
  transition: all var(--transition-fast) ease-out;
}

.icon-enter-from {
  position: absolute;
  opacity: 0;
}

.icon-leave-to {
  position: absolute;
  opacity: 0;
}
</style>
